import {
  Backtest,
  BacktestRunSummary,
  CreateBacktestRequest,
  EvaluationSource,
} from '@karehero/models';

import api from '.';

const LIST_ID = 'LIST';

export const evaluationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createBacktest: builder.mutation<Backtest, CreateBacktestRequest>({
      query: (body) => ({
        url: 'evaluation/backtests',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Backtest', id: LIST_ID }],
    }),
    listBacktests: builder.query<Backtest[], void>({
      query: () => ({ url: 'evaluation/backtests' }),
      providesTags: (result = []) => [
        { type: 'Backtest', id: LIST_ID },
        ...result.map(({ id }) => ({ type: 'Backtest' as const, id })),
      ],
    }),
    getBacktest: builder.query<Backtest, string>({
      query: (backtestID) => ({ url: `evaluation/backtests/${backtestID}` }),
      providesTags: (_result, _error, backtestID) => [
        { type: 'Backtest', id: backtestID },
      ],
    }),
    listBacktestRuns: builder.query<BacktestRunSummary[], string>({
      query: (backtestID) => ({
        url: `evaluation/backtests/${backtestID}/runs`,
      }),
      providesTags: (_result, _error, backtestID) => [
        { type: 'Backtest', id: backtestID },
      ],
    }),
    requestBacktestRun: builder.mutation<BacktestRunSummary, string>({
      query: (backtestID) => ({
        url: `evaluation/backtests/${backtestID}/runs`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, backtestID) => [
        { type: 'Backtest', id: LIST_ID },
        { type: 'Backtest', id: backtestID },
      ],
    }),
    listEvaluationSources: builder.query<EvaluationSource[], void>({
      query: () => ({ url: 'evaluation/sources' }),
      providesTags: [{ type: 'EvaluationSource', id: LIST_ID }],
    }),
  }),
});

export const invalidateBacktestTags = (backtestID: string | null) =>
  evaluationApi.util.invalidateTags([
    { type: 'Backtest', id: LIST_ID },
    ...(backtestID ? [{ type: 'Backtest' as const, id: backtestID }] : []),
  ]);

export const {
  useCreateBacktestMutation,
  useListBacktestsQuery,
  useGetBacktestQuery,
  useListBacktestRunsQuery,
  useRequestBacktestRunMutation,
  useListEvaluationSourcesQuery,
} = evaluationApi;

export default evaluationApi;
